import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { IGenericCardProps, PrivacySettingsCard } from '@gik/inkind-page';

export const pageSharingCardBlockName = 'page-sharing-card';

const PageSharingCard: React.FC<PropsWithClassName<IGenericCardProps>> = ({
  className,
  value,
  onChange,
  inputName,
}): JSX.Element => {
  const { t } = useTranslation();
  const bem = bemBlock(pageSharingCardBlockName);

  return (
    <PrivacySettingsCard
      className={bem(null, null, className)}
      title={t(translationKeys.pageSharingTitle)}
      icon={{
        set: 'gik-icons',
        name: value ? 'PageSharingOkOutline' : 'PageSharingDisabledOutline',
      }}
      description={
        value ? t(translationKeys.pageSharingDescription) : t(translationKeys.pageSharingDescriptionDisabled)
      }
      value={value}
      onChange={onChange}
      inputName={inputName}
    />
  );
};

export default PageSharingCard;
